import {
  FuturesAlternativeLinesMarketTypes,
  MarketTypes,
  SportsNameType,
} from "app/utils/const";
import { api } from "../helpers/apiHelperV3";
import { EventsAPIHelper } from "../helpers/eventsAPIHelper";
import { AlternativeLinesMarketTypes, MTSTabTypes } from "../utils/const";
import { urls } from "./urls";
const API_EVENTS = `${urls.data.API_MOBILE_EVENTS()}`;
const API_EVENTS__ASIAN = `${urls.data.API_ASIAN_EVENTS()}`;

/**
 * fetch a single event
 */
export const fetchEvent = (
  eventId: number,
  updatingEventList: boolean = false
): any => {
  const url = API_EVENTS + "/" + eventId;
  let params: {
    summarised: boolean;
  } = {
    summarised: false,
  };
  return api
    .get(url, {
      params: params,
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * fetch single event details for mobile
 * Uses same endpoint as asian event modal
 */
export const fetchEventDetails = (
  eventId: number,
  updatingEventList: boolean = false,
  marketTypes?: string
): any => {
  const url = API_EVENTS__ASIAN + "/" + eventId;
  let params: {
    summarised: boolean;
    line?: any;
    marketTypes?: any;
    periods?: string;
    marketGroup?: string;
  } = {
    summarised: false,
    line: "ALL",
  };

  // Modal Market Group filter params
  if (marketTypes) {
    params["marketGroup"] = marketTypes;

    if (marketTypes === MTSTabTypes.FIRSTHALF) {
      params["periods"] = "FIRST_HALF";
    }
  }

  return api
    .get(url, {
      params: params,
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * fetch event for desktop
 */
export const getEventDesktop = (
  eventId: number,
  updatingEventList: boolean = false,
  summarised: boolean = true,
  line?: string | null,
  marketType?: string | null,
  marketTypes?: string | null,
  showAlternativeLines?: boolean | null,
  sportType?: string | null
): any => {
  const url = EventsAPIHelper.getEventDesktopUrl(eventId);
  let params: {
    summarised: boolean;
    alternativeMarketTypes?: string;
    line?: any;
    "market-type"?: string;
    marketTypes?: any;
    periods?: string;
    marketGroup?: string;
  } = {
    summarised: summarised,
  };

  if (marketType && marketType !== MarketTypes.HANDICAP) {
    params["market-type"] = marketType;
  }

  // this function may not be neccessary but will leave in for the moment
  // in relation to PopularEventCell line 421
  EventsAPIHelper.getEventDesktopLine(line, params);

  if (showAlternativeLines) {
    if (sportType === SportsNameType.GOLF) {
      Object.assign(params, {
        alternativeMarketTypes: FuturesAlternativeLinesMarketTypes.join(","),
      });
    } else {
      Object.assign(params, {
        alternativeMarketTypes: AlternativeLinesMarketTypes.join(","),
      });
    }
  }

  // Modal Market Group filter params
  if (marketTypes) {
    params["marketGroup"] = marketTypes;

    if (marketTypes === MTSTabTypes.FIRSTHALF) {
      params["periods"] = "FIRST_HALF";
    }
  }

  return api
    .get(url, {
      params: params,
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * fetch event for desktop
 */
export const getEventDetailsDesktop = (
  eventId: number,
  updatingEventList: boolean = false,
  summarised: boolean = true,
  line?: string,
  marketType?: null | string,
  marketTypes?: string
): any => {
  const url = API_EVENTS__ASIAN + "/" + eventId;
  let params: {
    summarised: boolean;
    line?: any;
    "market-type"?: string;
    marketTypes?: any;
    periods?: string;
    marketGroup?: string;
  } = {
    summarised: summarised,
  };

  if (marketType && marketType !== MarketTypes.HANDICAP) {
    params["market-type"] = marketType;
  }

  // Modal Market Group filter params
  if (marketTypes) {
    params["marketGroup"] = marketTypes;

    if (marketTypes === MTSTabTypes.FIRSTHALF) {
      params["periods"] = "FIRST_HALF";
    }
  }

  return api
    .get(url, {
      params: params,
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * fetch a single event for the betslip
 * Returns a list of all markets for an event
 */
export const fetchEventForBetslip = (eventId: number): any => {
  const url = EventsAPIHelper.getEventDesktopUrl(eventId);
  let params: {
    summarised: boolean;
  } = {
    summarised: false,
  };
  return api
    .get(url, {
      params: params,
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * fetch event for euro desktop
 */
export const getEventEuroDesktop = (
  eventId: number,
  showAlternativeLines: boolean = false,
  sportType?: string
): any => {
  const url = EventsAPIHelper.getEventDesktopUrl(eventId);
  let params: {
    alternativeMarketTypes?: string;
  } = {};

  if (showAlternativeLines) {
    if (sportType === SportsNameType.GOLF) {
      Object.assign(params, {
        alternativeMarketTypes: FuturesAlternativeLinesMarketTypes.join(","),
      });
    } else {
      Object.assign(params, {
        alternativeMarketTypes: AlternativeLinesMarketTypes.join(","),
      });
    }
  }

  return api
    .get(url, {
      params: params,
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};
